<script>
import { Doughnut } from 'vue-chartjs'
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels';
import actions from '@/utils/defines/actions.js'

export default {
  extends: Doughnut,
  props: ['cubeEventCounts'],
  mixins: [actions],
  components: { ChartJsPluginDataLabels },
  data(){
    return {
      backgroundColors: []
    }
  },
  mounted() {
    this.options = {
      legend: {
        display: false,
        position: 'bottom'
      },
      tooltips: {
        enabled: true
      },
      plugins: {
        datalabels: {
          display: true,
          font: {
            size: 18
          },
          color: '#FFFFFF'
        }
      },
      maintainAspectRatio: false
    }
  },
  computed: {
    chartData() {
      return {
        labels: this.makeLabels,
        datasets: [{
          data: this.makeGraphData,
          backgroundColor: this.makeBackground,
          borderWidth: 1,
          hoverBackgroundColor: this.makeHoverBackground
        }]
      }
    },
    makeLabels() {
      return (this.checkEmpty()) ? [this.$t('Analysis.User.none')] : this.getLabels()
    },
    makeGraphData() {
      return (this.checkEmpty()) ? [1] : this.getGraphs()
    },
    makeBackground() {
      if(this.checkEmpty()){
        return ['#EEE']
      } else {
        const that = this;
        const count = this.makeLabels.length;
        this.actionTypes.map(function(actionType, index) {
          let alpha = 1 - (index * (1/count));
          let color = `rgba(0,156,225, ${alpha})`;
          if(actionType === '_unknown') {
            color = 'rgba(0,0,0,0.1)';
          }
          that.backgroundColors.push(color);
        });
        return this.backgroundColors;
        // ['#009CE1','#24AAE6','#47B7E9','#6BC5EE','#7FCDF0','#B2E1F6']
      }
    },
    makeHoverBackground() {
      return (this.checkEmpty()) ? ['#EEE'] : []
    },
    actionTypes() {
      return Object.keys(this.cubeEventCounts);
    }
  },
  methods: {
    getLabels : function()
    {
      return this.actionTypes.map(key => {
        const action = this.actions.find(action => action.type === key)
        return action ? this.$t(action.name) : []
      })
    },
    getGraphs : function()
    {
      return this.actionTypes.map(l => this.cubeEventCounts[l])
    },
    checkEmpty: function()
    {
      return this.getLabels().map(l => this.cubeEventCounts[l]).every(v => v === 0)
    },
    render : function()
    {
      let d = this.chartData.datasets
      let o = this.options
      let colors = ['#009CE1','#24AAE6','#47B7E9','#6BC5EE','#7FCDF0']

      if (this.checkEmpty()){
        d.hoverBackgroundColor = ['#EEE']
        d.backgroundColor = ['#EEE']
        d.borderWidth = 0
        o.plugins.datalabels.display = false
        o.tooltips.enabled = false
      } else {
        d.hoverBackgroundColor = this.makeHoverBackground
        d.backgroundColor = this.makeBackground
        d.borderWidth = 1
        o.plugins.datalabels.display = true
        o.tooltips.enabled = true
      }
      this.renderChart(this.chartData, this.options)
    }
  },
  watch : {
    cubeEventCounts() {
      this.render()
    }
  }
}
</script>
